import { render, staticRenderFns } from "./ArtistGroupAddModal.vue?vue&type=template&id=7cfe00c5&scoped=true&"
import script from "./ArtistGroupAddModal.vue?vue&type=script&lang=js&"
export * from "./ArtistGroupAddModal.vue?vue&type=script&lang=js&"
import style0 from "./ArtistGroupAddModal.vue?vue&type=style&index=0&id=7cfe00c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfe00c5",
  null
  
)

export default component.exports